import { Component, forwardRef, input } from '@angular/core';
import { PayeeIconComponent } from '../payee-icon/payee-icon.component';

@Component({
  selector: 'payee-info',
  templateUrl: './payee-info.component.html',
  styleUrls: ['./payee-info.component.scss'],
  imports: [PayeeIconComponent, forwardRef(() => PayeeInfoComponent)],
  host: {
    '[attr.width]': 'width()',
    '[attr.height]': 'height()',
  },
})
export class PayeeInfoComponent {
  readonly width = input<string>();
  readonly height = input<string>();
}
